var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6065 6.3934C28.9994 7.78628 30.1043 9.43987 30.8581 11.2598C31.6119 13.0796 31.9999 15.0302 31.9999 17C31.9999 18.9698 31.6119 20.9204 30.8581 22.7403C30.1043 24.5601 28.9994 26.2137 27.6065 27.6066C26.2136 28.9995 24.56 30.1044 22.7402 30.8582C20.9203 31.612 18.9697 32 16.9999 32C15.0301 32 13.0795 31.612 11.2597 30.8582C9.43978 30.1044 7.78619 28.9995 6.39331 27.6066L27.6065 6.3934Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 17C0.5 7.90024 7.90024 0.5 17 0.5C26.0998 0.5 33.5 7.90024 33.5 17C33.5 26.0998 26.0998 33.5 17 33.5C7.90024 33.5 0.5 26.0998 0.5 17ZM17 3.5C9.55709 3.5 3.5 9.55709 3.5 17C3.5 24.4429 9.55709 30.5 17 30.5C24.4429 30.5 30.5 24.4429 30.5 17C30.5 9.55709 24.4429 3.5 17 3.5ZM12.4037 12.4038C12.9895 11.818 13.9393 11.818 14.5251 12.4038L17 14.8787L19.4749 12.4039C20.0606 11.8181 21.0104 11.8181 21.5962 12.4039C22.182 12.9896 22.182 13.9394 21.5962 14.5252L19.1213 17L21.5961 19.4749C22.1819 20.0607 22.1819 21.0104 21.5961 21.5962C21.0103 22.182 20.0606 22.182 19.4748 21.5962L17 19.1214L14.5251 21.5962C13.9393 22.182 12.9896 22.182 12.4038 21.5962C11.818 21.0105 11.818 20.0607 12.4038 19.4749L14.8787 17L12.4037 14.5251C11.818 13.9393 11.818 12.9896 12.4037 12.4038Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.9d665d9eb2418668a333944b9f7829ed.svg";
export { ForwardRef as ReactComponent };